import { createRouter, createWebHashHistory } from 'vue-router'

// Layout
const Layout = () => import('../layout/index.vue')

// Views
const Home = () => import('../views/home/index.vue')
const QuestionBank = () => import('../views/question/index.vue')
const QuestionList = () => import('../views/question-list/index.vue')
const QuestionnaireList = () => import('../views/questionnaire/index.vue')
const QuestionnaireEditor = () => import('../views/questionnaire/editor.vue')
const FillQuestionnaire = () => import('../views/fill/index.vue')
const Dashboard = () => import('../views/dashboard/index.vue')

const ShortLinkRedirect = {
  template: '<van-loading size="36px" vertical style="padding-top:40vh">跳转中...</van-loading>',
  async created() {
    const code = this.$route.params.code
    try {
      const res = await fetch('/api/questionnaires/resolve/' + code)
      const json = await res.json()
      if (json.isSuccess && json.data) {
        this.$router.replace('/fill/' + json.data.id)
      } else {
        this.$router.replace('/')
      }
    } catch (e) {
      this.$router.replace('/')
    }
  }
}

const routes = [
  {
    path: '/s/:code',
    name: 'shortLink',
    component: ShortLinkRedirect,
    meta: { title: '问卷' }
  },
  {
    path: '/fill/:id',
    name: 'fillQuestionnaire',
    component: FillQuestionnaire,
    meta: { title: '答题' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: Home,
        meta: { title: '首页' }
      },
      {
        path: 'question',
        name: 'question',
        component: QuestionBank,
        meta: { title: '题库管理' }
      },
      {
        path: 'question-list',
        name: 'questionList',
        component: QuestionList,
        meta: { title: '题目列表' }
      },
      {
        path: 'questionnaire',
        name: 'questionnaire',
        component: QuestionnaireList,
        meta: { title: '问卷管理' }
      },
      {
        path: 'questionnaire/editor/:id?',
        name: 'questionnaireEditor',
        component: QuestionnaireEditor,
        meta: { title: '问卷编辑' }
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: { title: '数据看板' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
